
const baseGeneralUrl = "General"



  const endpoints = {
   
    getComplaintUserReasones:`${baseGeneralUrl}/GetGeneralComplaintBlockReasons`,
     getComplaintmentByAdvertReasons:`${baseGeneralUrl}/GetAdvertComplaintReasons`
  };
  
  export default endpoints;
  